import { useState } from 'react';

const readStoredValue = (key, defaultValue) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw === null ? defaultValue : JSON.parse(raw);
  } catch (error) {
    return defaultValue;
  }
};

// Same shape as `useState`, but the value survives a page switch or reload by mirroring
// itself into `sessionStorage` under `key`. `sessionStorage` (not `localStorage`) is
// deliberate: this is for resuming a selection within the current tab/session, not
// persisting it indefinitely across browser restarts.
const useSessionStorageState = (key, defaultValue) => {
  const [value, setValue] = useState(() => readStoredValue(key, defaultValue));

  const setPersistedValue = (update) => {
    setValue((state) => {
      const nextValue = typeof update === 'function' ? update(state) : update;
      try {
        window.sessionStorage.setItem(key, JSON.stringify(nextValue));
      } catch (error) {
        // sessionStorage can be unavailable (private browsing) or full — the in-memory
        // state above still works for the current render, it just won't survive a reload.
      }
      return nextValue;
    });
  };

  return [value, setPersistedValue];
};

export default useSessionStorageState;
